import detailStyles from '../ChallengeDetail.module.scss';
import image61 from './images/6-1.jpg';
import image92 from './images/9-2.jpg';
import image93 from './images/9-3.jpg';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';

export const StartBusinessDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>«Офис»</b>
                </div>
                <ChallengeDetailHelpImage image={image61} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Откройте вкладку <b>«Бизнес»</b>
                </div>
                <ChallengeDetailHelpImage image={image92} helpText='Это картинка. Ищите вкладку в разделе «Офис».' />
            </p>

            <p>
                <div>
                    Нажмите кнопку <b>«Начать новый»</b>
                </div>
                <ChallengeDetailHelpImage image={image93} helpText='Это картинка. Ищите кнопку на вкладке «Бизнес».' />
            </p>
        </div>
    );
}